import * as React from 'react';

interface Props {
  element: React.RefObject<HTMLElement>;
  className?: string;
}

export const ScrollToTop: React.FC<Props> = (props) => {
  const { element, className } = props;

  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const el = element.current;

    const handleScroll = () => {
      if (el) {
        setVisible(el.scrollTop > 0);
      }
    };

    if (el) {
      el.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (el) {
        el.removeEventListener('scroll', handleScroll);
      }
    };
  }, [element]);

  const handleClick = React.useCallback(() => {
    const el = element.current;
    if (el) {
      el.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [element]);

  return (
    <div
      className={`py-1 px-2 bg-gray-700 transition hover:bg-gray-600 rounded text-gray-100 absolute bottom-[12px] right-2/4 translate-x-2/4 cursor-pointer font-medium shadow-md md:shadow-none ${
        visible ? 'opacity-100' : 'opacity-0 pointer-events-none'
      } ${className || ''}`}
      onClick={handleClick}
    >
      <h5>Scroll to Top</h5>
    </div>
  );
};
